<template>
  <div class="question-add">
    <div class="question-title">
      <div class="title">答题卡名称</div>
      <van-field maxlength="50" v-model="name" placeholder="请输入答题卡名称" />
    </div>

    <!-- 单选 -->
    <template v-for="(title, index) in sortTitle">
      <radio @change-sort="onChangeSort" @on-del="onDelTitle" :title="title" :key="index" v-if="title.type === 1" />
      <checkbox @change-sort="onChangeSort" @on-del="onDelTitle" :title="title" :key="index" v-if="title.type === 2" />
      <addtion @change-sort="onChangeSort" @on-del="onDelTitle" :title="title" :key="index" v-if="title.type === 3" />
    </template>

    <div @click="showAction = true" class="question-add-btn">
      <van-icon name="plus" />
      <span>添加题目</span>
    </div>
    <div class="save-btn">
      <van-button @click="submit" block round type="info">保存</van-button>
    </div>

    <van-action-sheet v-model="showAction" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import {examAddOrEdit, getbase} from '@/api'
import {uuid} from '@/ultis'
import radio from './questionType/radio.vue'
import checkbox from './questionType/checkbox.vue'
import addtion from './questionType/addtion.vue'
export default {
  components: {
    radio,
    checkbox,
    addtion
  },
  data() {
    return {
      paperId: this.$route.query.paperId,
      id: this.$route.params.id,
      name: '',
      titles: [
        {
          isCorrect: 0,
          isMandatory: 0,
          name: '',
          options: [
            {
              content: '选项一',
              id: uuid(),
              isCorrect: 0,
              sort: 1
            },
            {
              content: '选项二',
              id: uuid(),
              isCorrect: 0,
              sort: 2
            }
          ],
          sort: 1,
          type: 1
        },
        {
          isCorrect: 0,
          isMandatory: 0,
          name: '',
          options: [
            {
              content: '选项一',
              id: uuid(),
              isCorrect: 0,
              sort: 1
            },
            {
              content: '选项二',
              id: uuid(),
              isCorrect: 0,
              sort: 2
            }
          ],
          sort: 2,
          type: 2
        },
        {
          isCorrect: 0,
          isMandatory: 0,
          name: '',
          options: [
            {
              content: '选项一',
              id: uuid(),
              isCorrect: 0,
              sort: 1
            },
            {
              content: '选项二',
              id: uuid(),
              isCorrect: 0,
              sort: 2
            }
          ],
          sort: 3,
          type: 3
        }
      ], // 题目
      /* actions */
      showAction: false,
      actions: [
        {name: '单选', type: 1},
        {name: '多选', type: 2},
        {name: '问答', type: 3}
      ]
    }
  },
  computed: {
    sortTitle() {
      if (!this.titles.length) return []
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const newarr = this.titles.sort((a, b) => {
        return a.sort - b.sort
      })
      return newarr
    }
  },
  created() {
    if (this.paperId) {
      document.title = '编辑答题卡'
      this.getDetail()
      //   编辑
    }
  },
  methods: {
    async getDetail() {
      const result = await getbase({paperId: this.paperId})
      if (result.code === 0) {
        this.titles = result.data.titles
        this.titles.forEach(item => {
          const options = item.options || []
          options.forEach(option => {
            option.id = uuid()
          })
        })
        this.name = result.data.name
      }
    },
    // ======编辑↑======
    onChangeSort({type, index}) {
      if (type === '-') {
        if (index === 0) {
          return this.$toast('已经是第一个')
        }
        const targetSort = this.titles[index - 1].sort
        const currentSort = this.titles[index].sort
        this.titles[index - 1].sort = currentSort
        this.titles[index].sort = targetSort
      } else {
        if (index === this.titles.length - 1) {
          return this.$toast('已经是最后一个')
        }
        const targetSort = this.titles[index + 1].sort
        const currentSort = this.titles[index].sort
        this.titles[index + 1].sort = currentSort
        this.titles[index].sort = targetSort
      }
    },
    onDelTitle(index) {
      this.titles.splice(index, 1)
      /* 修正sort值 */
      this.updateSort()
    },
    // 修正sort值
    updateSort() {
      this.titles = this.titles.map((item, index) => {
        const newItem = JSON.parse(JSON.stringify(item))
        newItem.sort = index + 1
        return newItem
      })
    },
    /* ====================================== */
    onSelect(item) {
      this.showAction = false
      const radioTem = {
        isCorrect: 0,
        isMandatory: 0,
        name: '',
        options: [
          {
            isCorrect: 0,
            content: '选项一',
            sort: 1,
            id: uuid()
          },
          {
            isCorrect: 0,
            content: '选项二',
            sort: 2,
            id: uuid()
          }
        ],
        sort: this.titles.length + 1,
        type: item.type
      }
      this.titles.push(radioTem)
    },
    async submit() {
      let flag = false
      let flagMesg = ''
      this.titles.forEach(title => {
        if (!title.name) {
          flag = true
          flagMesg = '请完善题目信息'
        }
        if (title.isCorrect === 1) {
          const options = title.options
          const hasCorrect = options.some(option => option.isCorrect === 1)
          if (!hasCorrect) {
            flag = true
            flagMesg = '请勾选正确答案'
          }
        }
      })
      if (flag) {
        return this.$Toast(flagMesg)
      }
      if (!this.name) {
        return this.$Toast('请输入答题卡名称')
      }
      if (this.titles.length === 0) {
        return this.$Toast('请添加题目')
      }
      const newTitles = JSON.parse(JSON.stringify(this.titles))
      newTitles.forEach(item => {
        delete item.answer // 编辑
        const options = item.options || []
        options.forEach(option => {
          delete option.id
          delete option.isChoose // 编辑
        })
      })
      const data = {
        eventId: this.id,
        name: this.name,
        titles: newTitles,
        type: 1
      }
      if (this.paperId) {
        data.eventExamPaperId = this.paperId
      }
      const result = await examAddOrEdit(data)
      if (result.code === 0) {
        this.$router.push(`/activeAddQueSuccess/${this.id}?paperId=${result.data}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.question-add {
  padding-bottom: 70px;
  position: relative;
}
.question-title {
  margin: 12px 0;
  background: #fff;
  .title {
    padding: 10px 16px 0;
    color: #909399;
  }
}
.question-add-btn {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4465f3;
  height: 48px;
}

.save-btn {
  position: fixed;
  padding: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.04);
}
</style>
